import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "progress-bar-container bg-light hide-on-app-closed" };
const _hoisted_2 = {
    class: "progress",
    style: { "height": "20px", "border-radius": "0" }
};
const _hoisted_3 = ["aria-valuenow"];
const _hoisted_4 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: "progress-bar progress-bar-striped progress-bar-animated",
                role: "progressbar",
                style: _normalizeStyle({ width: _ctx.progressPercent + '%' }),
                "aria-valuenow": _ctx.progressPercent,
                "aria-valuemin": "0",
                "aria-valuemax": "100"
            }, [
                (_ctx.displayProgress > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.displayMessage) + " (" + _toDisplayString(_ctx.progressPercent) + "%) ", 1))
                    : _createCommentVNode("", true)
            ], 12, _hoisted_3)
        ])
    ]));
}
